import type { SystemStyleObject } from "@chakra-ui/react"

const PANEL_FONT_FAMILY = "'Inter', sans-serif"

export const LIKERT_AUGMENTATION_TYPOGRAPHY_CSS: SystemStyleObject = {
  "&, & :where(*)": {
    fontFamily: `${PANEL_FONT_FAMILY} !important`
  },
  "& :where([class^='pwai-'], [class*=' pwai-'])": {
    fontFamily: "'pathicons' !important"
  }
}

export const LIKERT_AUGMENTATION_INPUT_PROPS = {
  bg: "rgba(0, 0, 0, 0.1)",
  borderRadius: "10px",
  h: "33px",
  px: "8px",
  fontFamily: PANEL_FONT_FAMILY,
  fontSize: "14px",
  lineHeight: "17px",
  _focusVisible: {
    boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.25)"
  },
  _mediaHoverNone: {
    fontSize: "16px",
    lineHeight: "20px"
  }
} as const

export const LIKERT_AUGMENTATION_MENU_CONTENT_PROPS = {
  backdropFilter: "blur(10px)",
  bg: "rgba(244, 247, 250, 0.98)",
  border: "none",
  borderRadius: "15px",
  boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.05), 0 3px 30px rgba(0, 0, 0, 0.15)",
  minW: 0,
  overflow: "hidden",
  p: "5px",
  w: "fit-content"
} as const

export const LIKERT_AUGMENTATION_OPTIONS_MENU_ITEM_GAP = "10px"

export const LIKERT_AUGMENTATION_OPTIONS_MENU_ITEM_CSS: SystemStyleObject = {
  alignItems: "center",
  bg: "transparent",
  borderRadius: "10px",
  gap: LIKERT_AUGMENTATION_OPTIONS_MENU_ITEM_GAP,
  justifyContent: "flex-start",
  minH: "30px",
  px: "8px",
  py: 0,
  fontFamily: PANEL_FONT_FAMILY,
  fontSize: "14px",
  lineHeight: "17px",
  w: "100%",
  "&:hover, &[data-highlighted], &[data-state='open']": {
    bg: "rgba(0, 0, 0, 0.1)",
    color: "#000"
  }
}

export const LIKERT_AUGMENTATION_MENU_ITEM_ICON_CSS: SystemStyleObject = {
  boxSize: "16px",
  opacity: 0.8
}
